import { IMarketplace } from "../../../../interfaces/IMarketplace"
import { Box, Breadcrumbs, Grid, Link, Typography } from "@mui/material";
import { ConteudoContainer, PageContainer, PainelContainer } from "../../styles";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
    BoltOutlined,
    PhonelinkLockOutlined,
    QrCode2Outlined,
    SmartToyOutlined
} from "@mui/icons-material";
import { IIntegracaoWhatsApp } from "../../../../interfaces/IIntegracaoMarketplace";
import { ConfigurarCredenciaisWhatsApp } from "../../../../components/whatsapp/ConfigurarCredenciaisWhatsApp";
import { ConfigurarComportamentosWhatsApp } from "../../../../components/whatsapp/ConfigurarComportamentosWhatsApp";
import { ConfigurarConexaoWhatsApp } from "../../../../components/whatsapp/ConfigurarConexaoWhatsApp";
import { ConfigurarMensagensRapidasWhatsApp } from "../../../../components/whatsapp/ConfigurarMensagensRapidasWhatsApp";
import { ConfigurarNumerosPermitidosWhatsApp } from "../../../../components/whatsapp/ConfigurarNumerosPermitidosWhatsApp";
import { CabecalhoWhatsApp } from "../../components/CabecalhoWhatsApp";
import { NavegacaoSecoes, SecaoNavegacao } from "../../components/NavegacaoSecoes";
import { PainelSecao } from "../../components/PainelSecao";

interface WhatsAppContainerProps {
    marketplace: IMarketplace;
    marketplaces: IMarketplace[];
    handleRefresh: () => void;
    loadingFetch: boolean;
}

type SecaoId = "conexao" | "atendimento" | "mensagens" | "restricoes";

const secoes: SecaoNavegacao<SecaoId>[] = [
    { id: "conexao", titulo: "Conexão", icone: <QrCode2Outlined /> },
    { id: "atendimento", titulo: "Atendimento", icone: <SmartToyOutlined /> },
    { id: "mensagens", titulo: "Mensagens rápidas", icone: <BoltOutlined /> },
    { id: "restricoes", titulo: "Restrições", icone: <PhonelinkLockOutlined /> },
];

export const WhatsAppContainer = ({ marketplace, marketplaces, handleRefresh, loadingFetch }: WhatsAppContainerProps) => {
    const integracao = marketplace?.configuracao?.integracao as IIntegracaoWhatsApp;
    const [conectado, setConectado] = useState<boolean | undefined>(undefined);

    // A seção fica na URL para não ser perdida quando a página é recarregada
    // depois de salvar uma configuração (handleRefresh remonta o container).
    const [parametros, setParametros] = useSearchParams();
    const secaoParametro = parametros.get("secao") as SecaoId | null;
    const secaoAtiva: SecaoId = secoes.some(secao => secao.id === secaoParametro)
        ? secaoParametro as SecaoId
        : "conexao";

    const setSecaoAtiva = (secao: SecaoId) => {
        const novosParametros = new URLSearchParams(parametros);
        novosParametros.set("secao", secao);
        setParametros(novosParametros, { replace: true });
    }

    return (
        <PageContainer>
            <Breadcrumbs aria-label="breadcrumb">
                <Link color="primary" href="/marketplace">
                    Marketplaces
                </Link>
                {marketplace && (
                    <Typography color="text.primary">{marketplace.nome}</Typography>
                )}
            </Breadcrumbs>
            {!integracao ? (
                <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
                    <Box sx={{ width: "100%", maxWidth: "560px" }}>
                        <ConfigurarCredenciaisWhatsApp
                            marketplace={marketplace}
                            refresh={handleRefresh}
                        />
                    </Box>
                </Box>
            ) : (
                <>
                    <Box sx={{ mt: 2 }}>
                        <CabecalhoWhatsApp marketplace={marketplace} conectado={conectado} />
                    </Box>
                    <ConteudoContainer>
                        <NavegacaoSecoes
                            secoes={secoes}
                            secaoAtiva={secaoAtiva}
                            onChange={setSecaoAtiva}
                        />
                        <PainelContainer>
                            <PainelSecao ativo={secaoAtiva === "conexao"}>
                                <Grid item xs={12} md={6}>
                                    <ConfigurarConexaoWhatsApp
                                        marketplace={marketplace}
                                        refresh={handleRefresh}
                                        onStatusChange={setConectado}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <ConfigurarCredenciaisWhatsApp
                                        marketplace={marketplace}
                                        refresh={handleRefresh}
                                    />
                                </Grid>
                            </PainelSecao>

                            <PainelSecao ativo={secaoAtiva === "atendimento"}>
                                <Grid item xs={12}>
                                    <ConfigurarComportamentosWhatsApp
                                        marketplaces={marketplaces}
                                        marketplace={marketplace}
                                        refresh={handleRefresh}
                                    />
                                </Grid>
                            </PainelSecao>

                            <PainelSecao ativo={secaoAtiva === "mensagens"}>
                                <Grid item xs={12}>
                                    <ConfigurarMensagensRapidasWhatsApp
                                        marketplace={marketplace}
                                        refresh={handleRefresh}
                                    />
                                </Grid>
                            </PainelSecao>

                            <PainelSecao ativo={secaoAtiva === "restricoes"}>
                                <Grid item xs={12}>
                                    <ConfigurarNumerosPermitidosWhatsApp
                                        marketplace={marketplace}
                                        refresh={handleRefresh}
                                    />
                                </Grid>
                            </PainelSecao>
                        </PainelContainer>
                    </ConteudoContainer>
                </>
            )}
        </PageContainer>
    );
}
